const nameRegex = /^[a-zA-Z ]+$/;
const countryRegex = /^[a-zA-Z ]+$/;
const companyNameRegex = /^[a-zA-Z0-9. ]*$/;
const urlRegex =
  /((([A-Za-z]{3,9}:(?:\/\/)?)(?:[-;:&=\+\$,\w]+@)?[A-Za-z0-9.-]+|(?:www.|[-;:&=\+\$,\w]+@)[A-Za-z0-9.-]+)((?:\/[\+~%\/.\w-_]*)?\??(?:[-\+=&;%@.\w_]*)#?(?:[\w]*))?)/;
// Exported so other rule sets can reuse THIS pattern instead of restating it.
// Byte-identical to the backend EMAIL_REGEX in constants.js. No `g` flag, so
// `test` is safe to share between callers.
export const emailRegex = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/i;
const fullNameRegex = /^([\w]{3,})+\s+([\w\s]{3,})+$/i;
const phoneRegex =
  /^[\+]?[(]?[0-9]{3}[)]?[-\s\.]?[0-9]{3}[-\s\.]?[0-9]{4,6}$/im;

const usernameRegex = /^([A-Za-z]|[A-Za-z][0-9_-]*|[0-9]*[A-Za-z])+$/;
const nameFreeRegex = /^([^0-9]*)$/;

export const freeRegex = (e) => {
  return nameFreeRegex.test(e);
};

export const validateEmail = (e) => {
  return emailRegex.test(e);
};
export const validatePhone = (e) => {
  return phoneRegex.test(e);
};
export const validatePassword = (e) => {
  return e.length >= 8;
};
export const validateName = (e) => {
  return nameRegex.test(e);
};
export const validateCountry = (e) => {
  return countryRegex.test(e);
};
export const validateUserName = (e) => {
  return usernameRegex.test(e);
};
export const validateCompanyName = (e) => {
  return companyNameRegex.test(e);
};
export const validateUrl = (e) => {
  return urlRegex.test(e);
};
export const validateFullName = (e) => {
  return fullNameRegex.test(e);
};

// Postal / ZIP codes have no universal format, so this only rejects obvious
// garbage: letters, digits, spaces and hyphens only, at least one alphanumeric,
// 3-12 characters. Keeps international formats valid (SW1A 1AA, K1A 0B1,
// 12345-6789, 100-0001).
// Deliberately loose: postal formats are country-specific and there is no
// universal pattern, so this only rejects obvious garbage rather than trying
// to be authoritative. Letters, digits, spaces and hyphens; 3-12 characters;
// and at least one DIGIT — every national postal system in use includes one,
// which is what separates "SW1A 1AA" from "abc def".
export const validatePostalCode = (e) => {
  const value = (e ?? "").toString().trim();
  if (value.length < 3 || value.length > 12) return false;
  if (!/^[A-Za-z0-9 -]+$/.test(value)) return false;
  return /[0-9]/.test(value);
};

export const getExtension = (filename) => {
  var parts = filename.split(".");
  return parts[parts.length - 1];
};
export const isVideo = (filename) => {
  var ext = getExtension(filename);
  switch (ext.toLowerCase()) {
    case "m4v":
    case "mpg":
    case "avi":
    case "mp4":
    case "wmv":
    case "flv":
    case "mkv":
    case "mov":
      return true;
  }
  return false;
};
export const validateSelectedFile = (selectedFile, setSelectedFile) => {
  const MAX_FILE_SIZE = 15360; // 5MB

  const fileSizeKiloBytes = selectedFile?.size / 1024;

  if (fileSizeKiloBytes > MAX_FILE_SIZE) {
    alert("File size is greater than maximum limit 15MB");
    return;
  }
  setSelectedFile(selectedFile);
};

export const isHttp = (string) => {
  var regex = /http/;
  if (regex.test(string)) {
    return true;
  } else {
    return false;
  }
};
